export default __webpack_public_path__ + "static/media/Medical Tourism In India.9d0011a0.png";